/**
 * Website money surface.
 *
 * OWNERSHIP: this file owns NOTHING about currency semantics. The single
 * pricing-presentation owner is `supabase/functions/_shared/money/presentation.ts`,
 * shared verbatim with the Malak edge runtime so the website and the
 * assistant can never diverge (P0-6).
 *
 * The only logic that lives here is browser-local display-currency
 * PERSISTENCE, which has no meaning in the edge runtime.
 */

export * from '@shared/money/presentation';

import {
  BASE_CURRENCY,
  isSupportedCurrency,
  type SupportedCurrency,
} from '@shared/money/presentation';

const DISPLAY_CURRENCY_KEY = 'eurocollis_display_currency';
const DISPLAY_CURRENCY_MANUAL_KEY = 'eurocollis_display_currency_manual';

export function getDisplayCurrency(): SupportedCurrency {
  if (typeof window === 'undefined') return BASE_CURRENCY;
  const stored = localStorage.getItem(DISPLAY_CURRENCY_KEY);
  return isSupportedCurrency(stored) ? (stored as SupportedCurrency) : BASE_CURRENCY;
}

/** True when the user explicitly picked a currency (overrides pickup-country default). */
export function hasManualCurrencyOverride(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(DISPLAY_CURRENCY_MANUAL_KEY) === '1';
}

export function setDisplayCurrency(currency: SupportedCurrency, opts?: { manual?: boolean }): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(DISPLAY_CURRENCY_KEY, currency);
  if (opts?.manual) localStorage.setItem(DISPLAY_CURRENCY_MANUAL_KEY, '1');
  window.dispatchEvent(new CustomEvent('currency-changed', { detail: currency }));
}

export function clearManualCurrencyOverride(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(DISPLAY_CURRENCY_MANUAL_KEY);
}
